import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";


function MainMenu(){
    return (
        <div >
            <div class="row" style={{background:'orange_'}}>
                <div className="container containeritems" >
                    {/* <div className="boxes">
                        <Link to="Tenders" className="menuitems" style={{textAlign:'center'}}><i class="fa fa-home" aria-hidden="true" style={{fontSize:'15pt',marginBottom:'00px'}}></i>
                        <p className="menuitems">Tenders</p></Link>
                    </div> */}
                     <div className="boxes">
                        <Link to="/" className="menuitems" style={{textAlign:'center'}}><i class="fa fa-home" aria-hidden="true" style={{fontSize:'15pt',marginBottom:'00px'}}></i>
                        <p className="menuitems">Home</p></Link>
                    </div>
                    <div className="boxes">
                        <Link to="History" className="menuitems" style={{textAlign:'center'}}><i class="fa fa-history" aria-hidden="true" style={{fontSize:'15pt',marginBottom:'00px'}}></i>
                        <p className="menuitems">History</p></Link>
                    </div>
                    <div className="boxes">
                        <Link to="https://booking.sreepadmanabhaswamytemple.org/" className="menuitems" style={{textAlign:'center'}}><i class="fa fa-globe" aria-hidden="true" style={{fontSize:'15pt',marginBottom:'00px'}}></i>
                        <p className="menuitems">Online Booking</p></Link>
                    </div>
                    <div className="boxes">
                        <Link to="Timing" className="menuitems" style={{textAlign:'center'}}><i class="fa fa-clock-o" aria-hidden="true" style={{fontSize:'15pt',marginBottom:'00px'}}></i>
                        <p className="menuitems">Darsan Time</p></Link>
                    </div>
                    <div className="boxes">
                        <Link to="Accommodation" className="menuitems" style={{textAlign:'center'}}><i class="fa fa-building" aria-hidden="true" style={{fontSize:'15pt',marginBottom:'00px'}}></i>
                        <p className="menuitems">Accommodation</p></Link>
                    </div>
                    <div className="boxes">
                        <Link to="Administration" className="menuitems" style={{textAlign:'center'}}><i class="fa fa-users" aria-hidden="true" style={{fontSize:'15pt',marginBottom:'00px'}}></i>
                        <p className="menuitems">Administration</p></Link>
                    </div>
                    <div className="boxes">
                        <Link to="Gallery" className="menuitems" style={{textAlign:'center'}}><i class="fa fa-image" aria-hidden="true" style={{fontSize:'15pt',marginBottom:'00px'}}></i>
                        <p className="menuitems">Gallery</p></Link>
                    </div>
                    <div className="boxes">
                        <Link to="Contact" className="menuitems" style={{textAlign:'center'}}><i class="fa fa-map-marker" aria-hidden="true" style={{fontSize:'15pt',marginBottom:'00px'}}></i>
                        <p className="menuitems">Contact</p></Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default MainMenu;